import PropTypes from 'prop-types';

export const SubscriptionCancelVPSModalProps = {
  cancelRenewalDescriptionLabel: PropTypes.string,
  cancelRenewalLabel: PropTypes.string,
  cancelImmediateDescriptionLabel: PropTypes.string,
  cancelImmediateLabel: PropTypes.string,
  continueButtonLabel: PropTypes.string,
  descriptionLabel: PropTypes.object,
  onCloseClick: PropTypes.func,
  onContinueButtonClick: PropTypes.func,
  onQuitButtonClick: PropTypes.func,
  quitButtonLabel: PropTypes.string,
  titleLabel: PropTypes.string,
  type: PropTypes.oneOf(['hosting', 'addon']),
  agreedOptionsLabel: PropTypes.object,
};

export const CancelOptions = {
  CANCEL_RENEWAL: 'CANCEL_RENEWAL',
  CANCEL_IMMEDIATE: 'CANCEL_IMMEDIATE',
};
